module.exports = __webpack_public_path__ + "img/logout-mobile.28bb9783.svg";